import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLocationsWithFilters } from './store/slice';
import LocationTopHead from './locationmasters-top-head';
import LocationContent from './locationmasters-content';
import LocationModals from './locationmasters-modals';
import { actions as locationsAction } from './store/slice';

const { resetFilters } = locationsAction;

const LocationView = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchLocationsWithFilters());
    // dispatch(fetchLocations({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => dispatch(resetFilters());
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Location</h4>
              </div>
            </div>
            <LocationTopHead />
          </div>
          <LocationContent />
          <LocationModals />
        </div>
      </div>
    </div>
  );
};

export default LocationView;
